import { type FC, type PropsWithChildren, createRef } from "react";

import { PrintAreaContext } from "./context";
import { useCreatePrintAreaCallback } from "./useCreatePrintAreaCallback";

export type PrintAreaProviderProps = PropsWithChildren<Record<never, never>>;

export const PrintAreaProvider: FC<PrintAreaProviderProps> = ({ children }) => {
	const printAreaContentRef = createRef<HTMLDivElement>();
	const printContentArea = useCreatePrintAreaCallback(printAreaContentRef);

	return (
		<PrintAreaContext.Provider
			value={{
				printAreaContentRef,
				printContentArea,
			}}
		>
			{children}
		</PrintAreaContext.Provider>
	);
};
